import script from "./CommonUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonUpload.vue?vue&type=script&setup=true&lang=js"

import "./CommonUpload.vue?vue&type=style&index=0&id=795cac9c&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795cac9c"]])

export default __exports__